import React from 'react';

export function Logo() {
    return <img src={`${process.env.PUBLIC_URL}/images/nss_logo.png`} alt="Noor" />;
}
